import {
  EventAggregationSnapshot,
  EventCategory,
  EventPriority,
  PersistedRuntimeEvent
} from '../contracts'

export class RuntimeEventAggregator {
  private static snapshot: EventAggregationSnapshot = {
    totalEvents: 0,
    byCategory: {},
    byPriority: {},
    byType: {},
    byStream: {},
    byExecutionId: {},
    byCorrelationId: {},
    lastUpdatedAt: null
  }

  static consume(event: PersistedRuntimeEvent): void {
    this.snapshot.totalEvents += 1
    this.snapshot.byCategory[event.category] = (this.snapshot.byCategory[event.category] || 0) + 1
    this.snapshot.byPriority[event.severity] = (this.snapshot.byPriority[event.severity] || 0) + 1
    this.snapshot.byType[event.type] = (this.snapshot.byType[event.type] || 0) + 1
    this.snapshot.byStream[event.stream] = (this.snapshot.byStream[event.stream] || 0) + 1

    const executionId = event.context.executionId
    this.snapshot.byExecutionId[executionId] = (this.snapshot.byExecutionId[executionId] || 0) + 1

    const correlationId = event.context.correlationId
    this.snapshot.byCorrelationId[correlationId] = (this.snapshot.byCorrelationId[correlationId] || 0) + 1

    this.snapshot.lastUpdatedAt = new Date()
  }

  static getSnapshot(): EventAggregationSnapshot {
    return {
      ...this.snapshot,
      byCategory: { ...this.snapshot.byCategory },
      byPriority: { ...this.snapshot.byPriority },
      byType: { ...this.snapshot.byType },
      byStream: { ...this.snapshot.byStream },
      byExecutionId: { ...this.snapshot.byExecutionId },
      byCorrelationId: { ...this.snapshot.byCorrelationId }
    }
  }
}